
























import {
    defineComponent,
    ref,
    onMounted,
    Ref,
} from '@vue/composition-api';
import VideoFeed from './components/feed.vue';
import Header from '@/components/head-nav/index.vue';
import AnimPlayer from '@/pure-components/anim-player/index.vue';
import { LOG_RECO } from '@/common/logger/logType';
import { useGuideAnim, useLottieUrlPrefix } from './hooks/useLottie';
import { useLog } from '@/common/log';
import { useReco } from './hooks';
import { useGrayPageConfig } from '@/common/config/useGrayPageConfig';
export default defineComponent({
    name: 'newRecoPage',
    metaInfo() {
        return {
            title: '精彩推荐-快手',
            meta: [
                {
                    name: 'keywords',
                    content:
                        '快手,快手官网,快手下载,kuaishou,快手直播伴侣,快手app,短视频app,快手直播',
                },
                {
                    name: 'description',
                    content:
                        '快手是一款国民级短视频App。在快手，了解真实的世界，认识有趣的人，也可以记录真实而有趣的自己。快手，拥抱每一种生活。',
                },
            ],
        };
    },
    components: {
        VideoFeed,
        Header,
        AnimPlayer,
    },
    setup() {
        const log = useLog();
        const { feedList, llsid, fetchMoreFeed } = useReco();
        const { isGrayPage } = useGrayPageConfig();

        const player: Ref<InstanceType<typeof AnimPlayer> | null> = ref(null);
        const tagKey = 'recoGuide';
        const lottiePrefix = useLottieUrlPrefix();
        const { showGuideLottie, playerConfig, handleAnimEnded } = useGuideAnim({
            animDom: player,
            path: `${lottiePrefix}img/lottie/reco-guide/guide.mp4`,
            tagKey,
        });
        function animEnded() {
            handleAnimEnded();
        }
        function clickGuideAnim() {
            handleAnimEnded();
        }

        onMounted(() => {
            log({
                type: 'PV',
            });
        });
        return {
            feedList,
            LOG_RECO,
            animEnded,
            showGuideLottie,
            playerConfig,
            llsid,
            isGrayPage,
            log,
            fetchMoreFeed,
            clickGuideAnim,
        };
    },
    beforeRouteUpdate(to, from, next) {
        this.log({
            type: 'PV',
            action: 'leave',
        });
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.log({
            type: 'PV',
            action: 'leave',
        });
        next();
    },
});
